import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpRequest,
    HttpErrorResponse,
    HttpInterceptor
} from '@angular/common/http';
import { Observable, throwError  } from 'rxjs';
// import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
// import { throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ERROR_HANDLER_INTERCEPTOR_I18N } from './error-handler.interceptor.i18n';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {

    constructor(
        private router: Router,
        public snackBar: MatSnackBar
    ) { }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        // Retry only safe methods. A network-level failure (e.g. opaque CORS
        // response with status 0) does not prove the backend never received
        // the request, so retrying a state-changing method risks executing
        // the same side effect twice.
        const isSafeMethod = req.method === 'GET' || req.method === 'HEAD';
        const stream$ = isSafeMethod
            ? next.handle(req).pipe(retry(1))
            : next.handle(req);
        return stream$
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let errorMessage = '';
                    if (error.error instanceof ErrorEvent) {
                        // client-side error
                        errorMessage = `Error: ${error.error.message}`;
                    } else {
                        // server-side error
                        // 優先順位: 1. message -> 2. errorMessage -> 3. オブジェクト全体のシリアライズ
                        const serverError = error.error;
                        let extractedMessage = '';

                        if (serverError) {
                            if (serverError.message) {
                                extractedMessage = typeof serverError.message === 'object' 
                                    ? JSON.stringify(serverError.message) 
                                    : serverError.message;
                            } else if (serverError.errorMessage) {
                                extractedMessage = typeof serverError.errorMessage === 'object' 
                                    ? JSON.stringify(serverError.errorMessage) 
                                    : serverError.errorMessage;
                            } else {
                                extractedMessage = JSON.stringify(serverError);
                            }
                        }

                        // 画面表示用には、ステータスコードと「抽出したメッセージ」を組み合わせる
                        errorMessage = `Error Status: ${error.status}\nMessage: ${extractedMessage || error.message}`;
                        
                        this.snackBar.open(ERROR_HANDLER_INTERCEPTOR_I18N.message.serverError, ERROR_HANDLER_INTERCEPTOR_I18N.button.close, {
                            duration: 10000
                        });
                    }
                    // return throwError(errorMessage);
                    return throwError(errorMessage);
                })
            );
    }
}
